class subcollection extends HTMLElement {
  constructor() {
    super();
    this.collectionCarousel();
  }

  collectionCarousel() {
    const swiperElement = this.querySelector(".subcollection-slider__swiper");
    if (!swiperElement) return;

    const slides = swiperElement.querySelectorAll(".swiper-slide");
    let targetIndex = 0;

    slides.forEach((slide, index) => {
      if (slide.dataset.sliderActive === "true") {
        targetIndex = index;
      }
    });

    const subslider = new Swiper(swiperElement, {
      loop: false,
      slidesPerView: 4,
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: 6,
          spaceBetween: 47
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        init: function () {
          this.slideTo(targetIndex);

          // Add 'active' class once (no toggle)
          const activeSlide = slides[targetIndex];
          if (activeSlide) {
            activeSlide.classList.add('active');
          }
        }
      }
    });
  }
}

customElements.define('subcollection-slider', subcollection);
